import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { IoImageOutline } from 'react-icons/io5';
import { ModalProvider } from 'vig-ui-library';
import { IdCardPreviewModal } from '@/Components/MagicLink/IdCardPreviewModal';

export type IdCardBadgeProps = {
    label: string;
    imageUrl: string | null;
    fileId: string | null | undefined;
    fileName: string | null | undefined;
    linkTokenHash: string | null;
};

const IdCardBadge = ({ label, imageUrl, fileId, fileName, linkTokenHash }: IdCardBadgeProps) => {
    const { openModal } = ModalProvider.useModal();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleClick = () => {
        if (!imageUrl || !fileId || !linkTokenHash) return;

        openModal({
            children: (onClose) => (
                <IdCardPreviewModal
                    imageUrl={imageUrl}
                    title={label}
                    fileName={fileName || 'ID Card'}
                    linkTokenHash={linkTokenHash}
                    requestFileId={fileId}
                    onClose={onClose}
                />
            ),
            sx: {
                width: isMobile ? '90%' : 'fit-content',
                maxWidth: '90vw',
                p: 0
            },
        });
    };

    if (!imageUrl) return null;

    return (
        <Box
            onClick={handleClick}
            sx={{
                display: 'flex',
                padding: '8px 16px',
                alignItems: 'center',
                gap: '4px',
                borderRadius: '8px',
                border: `1px solid ${theme.palette.primary.main}`,
                background: '#FFF',
                width: 'fit-content',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: '#f5f5f5',
                },
            }}
        >
            <IoImageOutline size={20} color={theme.palette.primary.main} />
            <Typography variant="body2" color="text.primary" fontWeight={400}>
                {label}
            </Typography>
        </Box>
    );
};

export default IdCardBadge;

